import React from 'react';

import { Button, Flex, InlineNotification, Text } from '@lucidhq/lucidium';

import { useCampaignManager } from '~/components/CampaignManager/CampaignManagerProvider';
import { t } from '~/utils/i18n';

export const NoCreatives = () => {
  const { goToStep, steps } = useCampaignManager();

  return (
    <Flex
      data-testid="review-no-creatives-block"
      lss={{ flexDirection: 'column' }}
    >
      <InlineNotification
        lss={{
          mb: 'xxl'
        }}
        palette="danger"
        title={t('campaignManager.review.creatives.noCreatives.title')}
      >
        <Text lss={{ mb: 'lg', display: 'block' }}>
          {t('campaignManager.review.creatives.noCreatives.description')}
        </Text>
      </InlineNotification>

      <Flex lss={{ justifyContent: 'center' }}>
        <Button
          emphasis="medium"
          onClick={() => goToStep(steps.MEDIA_TRACKING.id)}
        >
          {t('campaignManager.review.creatives.noCreatives.addCreatives')}
        </Button>
      </Flex>
    </Flex>
  );
};
